"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CallUtils_1 = require("./CallUtils");
;
class MaskNumber extends React.Component {
    render() {
        const { props } = this;
        return (React.createElement("div", { title: "Make a Call", onClick: () => CallUtils_1.CallUtils.callUser(props.userId, props.receiverPhoneNumber, props.meta), style: Object.assign({ cursor: "pointer" }, props.wrapperStyles), className: props.className },
            React.createElement("i", { className: "fa fa-phone", "aria-hidden": "true", style: { padding: "0px 5px" } }),
            React.createElement("span", { style: Object.assign({}, props.textStyles) }, props.shouldShowNumber ? props.phoneNumber : "Call User")));
    }
}
exports.MaskNumber = MaskNumber;
